module.exports = __webpack_public_path__ + "images/1d7dc71fa4d2d3c086efdc4922adcdd1-teacher1.jpg";